var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-mulish inline-block rounded-3xl bg-sky-blue text-dark-navy font-bold px-6 py-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }